import { FormattedMessage } from "react-intl";
import { useContractEmployeeValuationHistory } from "../../api/getContractEmployeeValuationHistory";
import ContractFieldHistoryDialog from "../ContractFieldHistoryDialog/ContractFieldHistoryDialog";

type TEmployeeValuationHistoryDialogProps = {
  open: boolean;
  contractId: string;
  contractName?: string;
  onClose: () => void;
};

const EmployeeValuationHistoryDialog = ({
  open,
  contractId,
  contractName,
  onClose,
}: TEmployeeValuationHistoryDialogProps) => {
  const historyQuery = useContractEmployeeValuationHistory({
    contractId,
    config: { enabled: open },
  });

  return (
    <ContractFieldHistoryDialog
      open={open}
      dialogId="employee-valuation-history-dialog"
      contractName={contractName}
      historyQuery={historyQuery}
      onClose={onClose}
      title={
        <FormattedMessage
          id="EmployeeValuation.Histórico de la valoración"
          defaultMessage="Histórico de la valoración"
        />
      }
      emptyText={
        <FormattedMessage
          id="EmployeeValuation.No hay cambios registrados en la valoración"
          defaultMessage="No hay cambios registrados en la valoración"
        />
      }
      errorText={
        <FormattedMessage
          id="EmployeeValuation.No se ha podido cargar el histórico de la valoración"
          defaultMessage="No se ha podido cargar el histórico de la valoración"
        />
      }
    />
  );
};

export default EmployeeValuationHistoryDialog;
